import types from './types';

const INITIAL_STATE = {
    presets: [],
    totalCount: 0,
    loading: false,
    page: 0,
    rowsPerPage: 50,
    searchTerm: ""
};

const presetsPageReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.SET_PRESETS:
            return { ...state, presets: action.payload };
        case types.SET_TOTAL_COUNT:
            return { ...state, totalCount: action.payload };
        case types.SET_LOADING:
            return { ...state, loading: action.payload };
        case types.SET_PAGE:
            return { ...state, page: action.payload };
        case types.SET_ROWS_PER_PAGE:
            return { ...state, rowsPerPage: action.payload };
        case types.SET_SEARCH_TERM:
            return { ...state, searchTerm: action.payload };
        case types.UPDATE_PRESET_ENABLED:
            return {
                ...state,
                presets: state.presets.map(preset =>
                    preset.id === action.payload.id
                        ? { ...preset, enabled: action.payload.enabled }
                        : preset
                )
            };
        default:
            return state;
    }
};

export default presetsPageReducer;
